<script>
    import {clickOutside} from '../lib/clickOutside.js';
    import {router} from "../lib/Router/Router.svelte";
    import app from "../stores/app";
    import user from "../stores/user";
    import cart from "../stores/cart";
    import Alert from "../stores/alerts";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import NumericControl from "../components/controls/NumericControl.svelte";

    const onQuantityChange = product => {
        cart.calculateTotals();
        cart.saveCookie();
    }

    const onRemoveProduct = product => {
        Alert.confirm("Αφαίρεση προϊόντος", `Να αφαιρεθεί το προϊόν "${product.name}" από το καλάθι σας;`, () => removeProduct(product.id));
    }

    const removeProduct = id => {
        cart.removeFromCart(id);
    }

    const onRegionChange = () => {
        cart.calculateTotals();
        cart.saveCookie();
    }

    const gotoCheckout = () => {
        close();
        router.go('/checkout')();
    }

    const gotoProducts = () => {
        close();
        router.go('/')();
    }

    const close = () => {
        $cart.show = false;
    }

    if (!$cart.region_id) {
        if ($user.region_id) {
            $cart.region_id = $user.region_id;
        } else {
            $cart.region_id = $app.regions[0].id;
        }
    }

    $: {
        cart.calculateTotals();
    }
</script>

<div class="side-cart" class:show={ $cart.show } use:clickOutside on:click_outside="{ close }">
    <div class="side-cart-heading">
        <h5 class="mb-0">Καλάθι Αγορών</h5>
        <div class="close" on:click={ close }>
            <AppIcon icon="x" size="18"/>
        </div>
    </div>
    <div class="side-cart-body">
        {#if $cart.products.length}
            <div class="cart-list mb-4">
                {#each $cart.products as product}
                    <div class="product">
                        <div class="name">
                            { product.name }
                        </div>
                        <div class="content">
                            <div class="quantity">
                                <NumericControl bind:value="{ product.quantity }" minValue="1"
                                                maxValue="{ product.max_quantity }"
                                                on:change={ () => onQuantityChange(product) }/>
                            </div>
                            <div class="price">
                                { product.total_price.toFixed(2) } €
                            </div>
                            <div class="remove" title="αφαίρεση από το καλάθι"
                                 on:click={ () => onRemoveProduct(product) }>
                                <AppIcon icon="trash" size="16" strokeWidth="2"/>
                            </div>
                        </div>
                    </div>
                {/each}
                <div class="totals">
                    <div class="title">
                        Μερικό σύνολο
                    </div>
                    <div class="price">
                        { $cart.total_price.toFixed(2) } €
                    </div>
                </div>
                {#if $cart.shipping_price > 0}
                    <div class="totals">
                        <div class="title">
                            Μεταφορικά
                        </div>
                        <div class="price">
                            { $cart.shipping_price.toFixed(2) } €
                        </div>
                    </div>
                {/if}
                <div class="small text-gray mt-3">
                    Οι τιμές δεν περιλαμβάνουν Φ.Π.Α.
                </div>
            </div>

            {#if cart.requiresAddress()}
                <div class="form-group">
                    <label>Αποστολή σε</label>
                    <select class="form-select" bind:value="{ $cart.region_id }" on:change={ onRegionChange }>
                        {#each $app.regions as region}
                            <option value="{ region.id }">{ region.name }</option>
                        {/each}
                    </select>
                </div>
            {/if}

            <p class="small text-gray">
                Παραγγελίες που λαμβάνονται έως τις 12μμ (μεσημέρι) αποστέλλονται αυθημερόν εφόσον υπάρχει απόθεμα.<br>
                Μετά τις 12 το μεσημέρι αποστέλλονται στην επόμενη ημέρα.
            </p>

            <button class="btn btn-primary btn-block mt-5" on:click={ gotoCheckout }>Μεταφορά στο Ταμείο</button>
            <button class="btn btn-default btn-block mt-2" on:click={ gotoProducts }>Συνέχεια αγορών</button>
        {:else}
            <div class="cart-icon">
                <i class="fa fa-shopping-cart"></i>
            </div>
            <p class="text-center">Το καλάθι σας είναι άδειο.</p>
        {/if}
    </div>
</div>

<style>
    .side-cart {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        width: 450px;
        background: #fff;
        z-index: 8500;
        box-shadow: 0 0 14px rgba(0, 0, 0, 0.21);
        transform: translateX(120%);
        transition: .3s all ease;
    }

    .side-cart.show {
        transform: translateX(0);
    }

    .side-cart-heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: var(--secondary-font);
        border-bottom: 1px solid #dddada;
        padding: 10px 20px;
    }

    .side-cart-body {
        padding: 20px;
    }

    .side-cart .side-cart-heading .close {
        padding: 5px;
        cursor: pointer;
    }

    .side-cart .cart-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 120px;
        height: 120px;
        font-size: 50px;
        color: #fff;
        background: #e1dede;
        border-radius: 50%;
        margin: 0 auto 20px auto;
    }

    .cart-list .product {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #EAEAEA;
        padding: 10px 0;
    }

    .cart-list .product .name {
        font-size: 14px;
        width: calc(100% - 230px);
    }

    .cart-list .product .content {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .cart-list .product .quantity {
        width: 130px;
    }

    .cart-list .product .price {
        font-size: 14px;
        width: 90px;
        text-align: right;
        padding-right: 10px;
    }

    .cart-list .product .remove {
        padding: 5px 5px;
        cursor: pointer;
    }

    .cart-list .totals {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0 0 0;
    }

    .cart-list .totals .price {
        font-weight: 600;
    }

    @media (max-width: 576px) {
        .side-cart {
            width: 100%;
        }

        .cart-list .product {
            display: block;
        }

        .cart-list .product .name {
            width: 100%;
            font-weight: 600;
            margin-bottom: 10px;
        }

        .cart-list .totals .price {
            padding-right: 0;
        }
    }
</style>